interface LogoProps {
  className?: string;
  size?: number;
}

const Logo: React.FC<LogoProps> = ({ className = '', size = 32 }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
    >
      {/* Background circle */}
      <circle cx="50" cy="50" r="46" fill="currentColor" className="text-background" />
      
      {/* Unified claw shape - arm, joint, and prongs as one connected path */}
      <path 
        d="M44 14 
           L56 14 
           L56 32 
           Q56 36 60 38
           L60 42
           Q60 48 65 50
           L75 72 
           Q77 78 72 80 
           L66 78 
           Q62 76 60 70 
           L56 58
           L56 74 
           Q56 82 50 84 
           Q44 82 44 74 
           L44 58
           L40 70 
           Q38 76 34 78 
           L28 80 
           Q23 78 25 72 
           L35 50
           Q40 48 40 42
           L40 38
           Q44 36 44 32
           Z" 
        fill="#f42525"
      />
      
      {/* Joint circle cutout/detail */}
      <circle cx="50" cy="42" r="6" fill="currentColor" className="text-background" />
      
      {/* Center dot */}
      <circle cx="50" cy="42" r="2.5" fill="#f42525" />
    </svg>
  );
};

export default Logo;
